import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "d-flex flex-row gap-3 mb-2" }
const _hoisted_4 = { class: "font-weight-bolder text-dark m-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "d-flex gap-3 ps-4 align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history fs-2 text-white" }, null, -1)
const _hoisted_8 = { class: "w-100px" }
const _hoisted_9 = { class: "drawer-footer" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_Form1 = _resolveComponent("Form1")!
  const _component_Form2 = _resolveComponent("Form2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isDrawerOpen,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isDrawerOpen) = $event)),
    "show-close": false,
    direction: "ltr",
    class: "drawer-custom w-600px",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    header: _withCtx(({ close, titleId }) => [
      _createElementVNode("div", {
        id: titleId,
        class: "d-flex align-items-start justify-content-between"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.itemForm?.form_name), 1),
            _createElementVNode("span", {
              class: _normalizeClass(`badge rounded-pill badge-${_ctx.itemForm?.status?.params}`)
            }, _toDisplayString(_ctx.itemForm?.status?.name_es), 3)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.itemForm?.form_details), 1)
        ]),
        _createElementVNode("i", {
          class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
          onClick: close
        }, null, 8, _hoisted_5)
      ], 8, _hoisted_1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.formExpired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDrawerOpen = false)),
                color: 'var(--bs-info)'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((_ctx.childComponentRef?.formQ.mstatus == 4) ? _ctx.t("cancel") : _ctx.t("close")), 1)
                ]),
                _: 1
              }, 8, ["color"]),
              (_ctx.childComponentRef?.formQ.mstatus == 4)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    loading: _ctx.loading,
                    type: "primary",
                    plain: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAsDraf()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("save2")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              (_ctx.childComponentRef?.formQ.mstatus == 4)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    color: 'var(--bs-info)',
                    loading: _ctx.loading,
                    disabled: !_ctx.isFormLoaded,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAndSend()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("save1")), 1)
                    ]),
                    _: 1
                  }, 8, ["color", "loading", "disabled"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDrawerOpen = false)),
              color: 'var(--bs-info)'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("close")), 1)
              ]),
              _: 1
            }, 8, ["color"]))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex justify-content-between align-items-center mb-5", _ctx.formExpired ? '' : 'bg-info text-white rounded'])
      }, [
        (!_ctx.formExpired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('dateEnd')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.itemForm)
          ? (_openBlock(), _createBlock(_component_CountDown, {
              key: 1,
              fechafin: _ctx.itemForm.end_date,
              "class-name": "text-center h5 fw-bolder mb-0 text-white",
              "class-text": "mb-0 fw-bolder",
              subtitle: "font-size:10px;",
              onChangeStatus: _ctx.changeStatus
            }, null, 8, ["fechafin", "onChangeStatus"]))
          : _createCommentVNode("", true)
      ], 2),
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.idForm == 1)
          ? (_openBlock(), _createBlock(_component_Form1, {
              key: 0,
              ref: "childComponentRef",
              idevent: _ctx.idEvent,
              onFormLoaded: _ctx.onFormLoaded
            }, null, 8, ["idevent", "onFormLoaded"]))
          : _createCommentVNode("", true),
        (_ctx.idForm == 2)
          ? (_openBlock(), _createBlock(_component_Form2, {
              key: 1,
              ref: "childComponentRef",
              idevent: _ctx.idEvent,
              onFormLoaded: _ctx.onFormLoaded
            }, null, 8, ["idevent", "onFormLoaded"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}